import React from "react";
import PropTypes from "prop-types";
import IconHide from "../icons/IconHide";
import { Container } from "./styled/stream-item-hide";

function StreamItemHide({
  streamItemId,
  hidden,
  type,
  disabled,
  setStreamItemHide
}) {
  return (
    <Container
      active={hidden}
      disabled={disabled}
      onClick={() =>
        !disabled && setStreamItemHide({ streamItemId, hidden: !hidden, type })
      }>
      <IconHide />
    </Container>
  );
}

StreamItemHide.propTypes = {
  streamItemId: PropTypes.string.isRequired,
  hidden: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  setStreamItemHide: PropTypes.func.isRequired
};

export default StreamItemHide;
